module.exports = __webpack_public_path__ + "static/img/search-nodata.8203195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/on-job/search-nodata.png
// module id = KPt3
// module chunks = 4